<template>
    <div>
        <v-main>
            <span class="background-image"></span>    
            <span class="background-filter"></span>                
            <navBar title="Ares - Main menu" :home="true" :accolist="true" type="customersuccess"/>
            <v-row dense>
              <complaints /> 
              <rebookings /> 
              <damages />
              <changes />
              <reviews />
            </v-row>
        </v-main>
    </div>
</template>

<script>
    //  todo - home moet naar  /syst/ref/aftercare/aftercareDashboard en neit naar het hoofddashboard
    import navBar from "@/components/ui/navbars/navbar.vue";
    import complaints from "@/views/task/customer_success/complaintsAftercare.vue"
    import rebookings from "@/views/task/customer_success/rebookingsAftercare.vue"
    import damages from "@/views/task/customer_success/damagesAftercare.vue"
    import changes from "@/views/task/customer_success/changesAftercare.vue"
    import reviews from "@/views/task/customer_success/reviewsAftercare.vue"

    export default {        

        components: {
          navBar,
          complaints,
          rebookings,
          damages,
          changes,
          reviews
        },
        destroyed() {
        },              
        mounted() {
        },             
        data() {
            return {      
                test: '',
                loading: false,
            }
        },    
        methods: {
        },           
    }
</script>

<style scoped>
  .background-image {
    width: 100%;
    height: 100%;
    position: fixed; /* absolute */
    top: 0;
    left: 0;
    background: url('../../../assets/dashboard/w_background.png') no-repeat right bottom;
    background-size: cover;
    background-color: white;
    transform: scale(1.1);
  }  
  .background-filter{
    background: rgba(255,255,255,0.7);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

</style>
